export { baseRadioPropDefs as radioPropDefs } from './_internal/base-radio.props.js';
